<template>
  <validation-provider
    :name="name"
    :rules="rules"
    v-slot="{ errors }"
    style="width: 100%"
    mode="passive"
    ref="providerItems"
  >
    <label class="__input_wrap" :class="disabled ? '__disabled' : ''">
      <span class="__input_controls">
        <slot name="icon-fist"></slot>
      </span>
      <input
        class="__input"
        :placeholder="placeholder"
        :disabled="disabled"
        v-model="valueInput"
        @input="getValue(valueInput)"
        @keydown.enter.prevent="$emit('enter',$event)"
      />
      <span v-if="hideIcon" class="__input_controls" @click="clear(valueInput)">
        <slot name="icon-last"></slot>
      </span>
    </label>

    <span id="error" v-if="errors[0] || validateInput != ''" class="is-invalid">
      {{ validateInput != "" ? validateInput : errors[0] }}
    </span>
  </validation-provider>
</template>

<script>
export default {
  props: {
    type: {
      value: String,
      default: "text",
    },
    placeholder: {
      value: String,
      default: "",
    },
    disabled: {
      value: Boolean,
      default: false,
    },
    hideIcon: {
      value: Boolean,
      default: false,
    },
    value: {
      value: String,
      default: "",
    },
    name: {
      value: String,
      default: "",
    },
    rules: {
      value: String,
      default: "",
    },
    validate: {
      value: Array,
      default: () => [],
    },
  },

  data() {
    return {
      valueInput: this.value,
      validateInput: this.validate,
    };
  },

  model: {
    prop: "getVmodel",
    event: "value",
  },

  methods: {
    clear(value) {
      this.valueInput = "";
      this.$emit("clear", value);
    },
    getValue(value) {
      this.$emit("value", value);
      this.validateInput = [];
      this.$refs.providerItems.errors = [];
    },
  },

  watch: {
    value: {
      handler: function () {
        this.valueInput = this.value;
      },
      deep: true,
    },

    validate: {
      handler: function () {
        this.validateInput = this.validate;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.is-invalid {
  color: red;
}

.__input_wrap {
  all: unset;
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #dddddd !important;
  padding: 12px 12px 12px 16px;
  cursor: text;
  height: 46px;

  .__input {
    flex: 1 1 100%;
    width: 0;
    padding: 0;

    background: #ffffff;

    position: relative;

    &::placeholder {
      color: #c7c9d1;
    }
  }

  .__input_controls {
    flex: 0 0 auto;

    display: inline-flex;
    flex-flow: row;
    place-content: center;
    place-items: center;

    gap: 8px;

    padding-right: 8px;
    // margin-right: 8px;
    background-color: #fff;

    > * {
      cursor: pointer;
    }
  }
}
</style>
